// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"06b014aa","261":"282eae3f","338":"9abedd3b","456":"0c7fc4c0","541":"1bb9e19b","544":"e9b0dab3","576":"df890cff","753":"f7a8bb48","775":"5c8d92c6","805":"91230d5f","823":"1a56ef3f","980":"2ab12089"}[chunkId] + ".js";
};